// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"383afd8d","239":"e39fb35b","455":"526346da","977":"240addac"}[chunkId] + ".chunk.js";
};